import React, { useEffect, useRef } from 'react'
import clsx from 'clsx'
import { IconMaps } from '@ow/icons'
import { Tooltip } from '@ow/comps'
import { StyledArticleList } from './styled/article'
import useArticle from './hooks/article'
import InlineRenders from '../renders/inline-renders'
import BlockRenders from '../renders/block-renders'

const RenderAccountTypeIcon = function ({ isPublic }) {
  return (
    <IconMaps
      width={16}
      height={16}
      size={16}
      type={isPublic ? 'authPublicIcon' : 'authPrivateIcon'}
    />
  )
}

const ArticleList = function ({
  articleConfig,
  articleData,
  tbFields,
  pageNum,
  openDetail,
}) {
  const {
    isSimpleList,
    imagePosition,
    imageIsLine,
    tagSlug,
    titleSlug,
    summarySlug,
    createBySlug,
    dateSlug,
    imageSlug,
    type,
    styleSize,
    tagColors,
    accountTypeSlug,
    showSplit,
    bottomField_main = [],
    isShowSide,
    toThousands,
  } = useArticle(articleConfig)

  const articleRef = useRef()
  useEffect(() => {
    if (articleRef && articleRef.current) {
      articleRef.current.scrollTo(0, 0)
    }
  }, [pageNum])

  return (
    <StyledArticleList
      className={clsx([
        'article-list h-full overflow-auto dark:bg-darkTheme-1100 flex flex-col',
        type === 'boxing' && 'gap-2',
      ])}
      isShowSizde={isShowSide}
      isSimpleList={isSimpleList}
      tagSlug={tagSlug}
      showSplit={showSplit}
      ref={articleRef}
    >
      {articleData.map((item, index) => {
        return (
          <div
            key={item.tableDataId}
            className={clsx([
              'article-list-item',
              'gap-4',
              !isSimpleList &&
                'hover:bg-primary-50 dark:hover:bg-darkTheme-900',
              // 图片为横向摆放 && 有图片
              imageIsLine && imageSlug && 'flex',
              // 如果图片居左，文字和图片调换顺序
              imagePosition === 'left' && 'flex-row-reverse justify-end',
              type === 'boxing' && 'dark:bg-darkTheme-900',
            ])}
          >
            <div
              className="article-list-item-left flex-1"
              style={{
                width: imageIsLine && item[imageSlug] ? '563px' : '100%',
              }}
            >
              <div className="flex items-center">
                {tagSlug && (
                  <p
                    className="article-tag"
                    style={{ background: tagColors[index % tagColors.length] }}
                  >
                    {item[tagSlug]}
                  </p>
                )}
                {titleSlug && (
                  <div onClick={() => openDetail(item)}>
                    <InlineRenders
                      className={clsx([
                        'article-title cursor-pointer text-gray-100 hover:text-primary-700 dark:text-dark-200 hover:dark:text-dark-200',
                        styleSize === 'md' && 'font-size-md',
                        styleSize === 'lg' && 'font-size-lg',
                      ])}
                      value={item[titleSlug]}
                      fields={tbFields}
                      defs={tbFields.find((v) => v.slug === titleSlug)}
                    />
                  </div>
                )}
              </div>
              {summarySlug && item[summarySlug] && (
                <div onClick={() => openDetail(item)}>
                  <InlineRenders
                    className={clsx(
                      'article-content',
                      titleSlug ? 'article-sub' : 'article-main',
                      'text-gray-200 dark:text-dark-300',
                      'font-size-sm'
                    )}
                    value={item[summarySlug]}
                    fields={tbFields}
                    defs={tbFields.find((v) => v.slug === summarySlug)}
                  />
                </div>
              )}
              {!imageIsLine && item[imageSlug] && (
                <div className="article-block-image-body">
                  <BlockRenders
                    className="img-content"
                    rowData={item}
                    value={item[imageSlug]}
                    fields={tbFields}
                    defs={tbFields.find((v) => v.slug === imageSlug)}
                  />
                </div>
              )}
              <div className="bottom-info">
                {(createBySlug || accountTypeSlug) && (
                  <div className="flex items-center">
                    {createBySlug && (
                      <InlineRenders
                        className="article-author"
                        value={item[createBySlug]}
                        fields={tbFields}
                        defs={tbFields.find((v) => v.slug === createBySlug)}
                      />
                    )}
                    {accountTypeSlug && (
                      <Tooltip
                        trigger={
                          <span>
                            <RenderAccountTypeIcon
                              isPublic={item[accountTypeSlug]}
                            />
                          </span>
                        }
                        position="bottom"
                        on={['hover']}
                        arrow="top"
                        style={{
                          background: 'white',
                          color: 'rgba(0,0,0,.9)',
                          width: 'auto',
                          opacity: 1,
                          padding: '4px 14px 4px 6px',
                          boxShadow:
                            '0 5px 5px -3px rgba(0,0,0,0.10), 0 -8px 10px 1px rgba(0,0,0,0.06), 0 3px 14px 2px rgba(0,0,0,0.05)',
                        }}
                        arrowStyle={{ color: 'white' }}
                      >
                        <span className="flex items-center">
                          <RenderAccountTypeIcon
                            isPublic={item[accountTypeSlug]}
                          />
                          <span>
                            {item[accountTypeSlug] ? '官方账号' : '私人账号'}
                          </span>
                        </span>
                      </Tooltip>
                    )}
                  </div>
                )}
                {dateSlug && (
                  <InlineRenders
                    className="forward-text text-gray-200 dark:text-dark-300"
                    value={item[dateSlug]}
                    fields={tbFields}
                    defs={tbFields.find((v) => v.slug === dateSlug)}
                  />
                )}
                {bottomField_main.map((field) => {
                  return (
                    <div className="flex items-center">
                      {field.icon && (
                        <div>
                          <IconMaps
                            width={16}
                            height={16}
                            type={field.icon}
                            fill={field.iconFill}
                          />
                        </div>
                      )}
                      <div
                        className={clsx([
                          'flex',
                          'items-center',
                          field.titlePosition &&
                            field.titlePosition === 'left' &&
                            'flex-row-reverse',
                        ])}
                      >
                        <InlineRenders
                          className="number text-gray-200 dark:text-dark-300"
                          value={toThousands(item[field.slug])}
                          fields={tbFields}
                          defs={tbFields.find((v) => v.slug === field.slug)}
                        />
                        {field.showTitle && (
                          <span className="text text-gray-200 dark:text-dark-300">
                            {field.title}
                          </span>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
            {imageIsLine && imageSlug && item[imageSlug] && (
              <div className="article-list-item-right">
                <BlockRenders
                  className="img-content"
                  rowData={item}
                  value={[item[imageSlug][0]]}
                  fields={tbFields}
                  defs={tbFields.find((v) => v.slug === imageSlug)}
                />
              </div>
            )}
          </div>
        )
      })}
    </StyledArticleList>
  )
}

export default ArticleList
